import React from "react";
import formatDate from "utils/formateDate";
import { formatDateTime } from "utils/formattedDateAndTime";
import generatedFormatDate from "utils/generatedDate";

const ObservationInformation = ({ rowData }) => {
  const patientData = rowData[0];

  console.log("patientData", patientData);

  return (
    <>
      <div className="modal-body">
        <div className="row">
          <div className="col-md-6">
            <div className="info-item">
              <span className="info-label">Appointment ID:</span>
              <span className="info-value">
                {patientData?.registration_id || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Patient Name:</span>
              <span className="info-value">
                {patientData?.patient_name || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Phone/Mobile:</span>
              <span className="info-value">
                {patientData?.patient_obj?.mobile || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Refer Doctor:</span>
              <span className="info-value">
                {patientData?.refer_doctor_name || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Register Date:</span>
              <span className="info-value">
                {formatDateTime(
                  patientData?.pateint_investigtion_details[0]
                    ?.register_by_date,
                ) || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Collected Date:</span>
              <span className="info-value">
                {formatDateTime(
                  patientData?.pateint_investigtion_details[0]?.collection_date,
                ) || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Rejected Date:</span>
              <span className="info-value">
                {formatDateTime(patientData?.rejected_date) || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Phlebot Name:</span>
              <span className="info-value">
                {patientData?.phlebot_name || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Result Entered Date:</span>
              <span className="info-value">
                {formatDateTime(
                  patientData?.pateint_investigtion_details[0]
                    ?.report_entered_date,
                ) || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Approved By:</span>
              <span className="info-value">
                {patientData?.pateint_investigtion_details[0]
                  ?.approved_by_name || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Approved Login By:</span>
              <span className="info-value">
                {patientData?.pateint_investigtion_details[0]
                  ?.approved_by_name || "N/A"}
              </span>
            </div>
          </div>
          <div className="col-md-6">
            <div className="info-item">
              <span className="info-label">Sample Type:</span>
              <span className="info-value">
                {patientData?.pateint_investigtion_details[0]
                  ?.investigation_name || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Age / Sex:</span>
              <span className="info-value">
                {patientData?.patient_age
                  ? `${patientData.patient_age.year} Y ${
                      patientData.patient_age.month
                    } M ${patientData.patient_age.days} D / ${
                      patientData.gender?.toLowerCase() === "male" ? "M" : "F"
                    }`
                  : "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Department:</span>
              <span className="info-value">
                {patientData?.pateint_investigtion_details[0]
                  ?.department_name || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Panel:</span>
              <span className="info-value">
                {patientData?.franchise_code || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Register By:</span>
              <span className="info-value">
                {patientData?.pateint_investigtion_details[0]
                  ?.register_by_name || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Collected By:</span>
              <span className="info-value">
                {patientData?.pateint_investigtion_details[0]
                  ?.collected_by_name || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Lab Received By:</span>
              <span className="info-value">
                {patientData?.lab_received_by || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Rejected User:</span>
              <span className="info-value">
                {patientData?.pateint_investigtion_details[0]
                  ?.rejected_by_name || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Sample Reject Reason:</span>
              <span className="info-value">
                {patientData?.pateint_investigtion_details[0]
                  ?.rejection_reason || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Result Entered By:</span>
              <span className="info-value">
                {patientData?.pateint_investigtion_details[0]
                  ?.report_entered_by_name || "N/A"}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Approved Date:</span>
              <span className="info-value">
                {formatDateTime(
                  patientData?.pateint_investigtion_details[0]?.approved_date,
                ) || "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ObservationInformation;
